import { MovingAppNextPage } from 'types';
import Onboarding from '../../components/OnboardingWrapper';

const SignUpPages: MovingAppNextPage = () => {
  return <Onboarding />;
};

SignUpPages.allowUnauthorized = true;
export default SignUpPages;
